import { type FC, type ReactNode } from 'react';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel.tsx';

import styles from './Header.scss';

type Props = {
    title: ReactNode;
};

const Header: FC<Props> = ({ title }) => {
    return (
        <HeadingLevel>
            {Heading => <Heading className={styles.header}>{title}</Heading>}
        </HeadingLevel>
    );
};

export default Header;
